import { render, staticRenderFns } from "./QQlogin.vue?vue&type=template&id=f9e35b68&scoped=true"
import script from "./QQlogin.vue?vue&type=script&lang=js"
export * from "./QQlogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e35b68",
  null
  
)

export default component.exports